import Vue from 'vue'
import router from './router'
// import store from './store'
import settings from './settings'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import Cookies from './utils/cookies'
import User from './api/user'

import ls from 'store2'

NProgress.configure({ showSpinner: false })

const whiteList = ['/', '/register']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = settings.title

  const jyToken = Cookies.getToken()
  const user = ls.session('USER')

  // 白名单直接跳转
  if (whiteList.indexOf(to.path) !== -1) {
    next();
    NProgress.done()
    return;
  }
  // 没有unionid跳转到登录页
  if (!jyToken) {
    next(`/`)
    NProgress.done()
    return;
  }
  // console.log("===permission:user", user)
  // 有user信息,并且访问主页面，直接跳转到主页
  if (user != null && user.id != null && to.path === '/') {
    next({ path: '/normal/dashboard' })
    NProgress.done()
    return;
  }

  // 有user信息,并且访问登录页，直接跳转到主页
  if (user != null && user.id != null) {
    next()
    NProgress.done()
    return;
  }

  // 没有user信息，获取user 信息
  const userRes = await User.findByUnionid({ unionid: jyToken })

  // console.log("===permission:userRes", userRes)

  // 后台无响应
  if (userRes.data.code != 200) {
    next(`/`)
    Cookies.removeToken()
    Cookies.removeTokenLijianlifu()
    ls.clearAll();
    Message.error('登录已失效，请重新登录！')
    return;
  }

  // 用户登录授权已失效
  if (jyToken != userRes.data.entity.webToken) {
    next(`/`)
    Cookies.removeToken()
    Cookies.removeTokenLijianlifu()
    ls.clearAll();
    Message.error('登录已失效，请重新登录')
    return;
  }

  // 保存user信息
  const userData = userRes.data.entity
  const tenant = userData.tenant
  ls.session('USER', userData)
  ls.session('TENANT', tenant)

  const userAuthRes = await UserAuth.findByIdWeddingDressHall(userData.id)
  const userAuth = userAuthRes.data.entity
  Vue.set(userData, "_shopId", userAuth.shopId);
  Vue.set(userData, "_shopName", userAuth.shopName);
  Vue.set(userData, "_manageUsers", userAuth.manageUsers);
  Vue.set(userData, "_actionsJson", userAuth.actionsJson);
  Vue.set(userData, "_permissions", userAuth.permissions);
  ls.session('USER', userData)
  ls.session('TENANT', tenant)
  next(to.path)
})

router.afterEach(() => {
  NProgress.done()
})
